import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { getInsuranceTypeBEName } from '../../../../../../itrust_common/components/HelperFunctions'
import { orderLoad } from '../../../../../../redux/actions/order/orderActions'
import { isDirty, submit } from 'redux-form'
import { getInsuranceFromRPAServices, isRpaVerifiedInsurance } from '../../../other/AddOnsHelperFunctions'
import { RenderRPAService } from './RenderRPAServiceButton'
import { visionInsuranceDetailView, visionInsuranceEligibilityReset, visionInsuranceEligibilityVerify } from '../../../../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceAction'
import { patientLoad } from '../../../../../../redux/actions/patient/patientActions'
import useInsuranceMappedFailed from '../useInsuranceMappedFailed'

function RPAInsuranceVerify(props) {
  const { patientId, orderId, patient, selectedInsuranceName, currentStoreId, insuranceType, services, isOrderView, isPatientView, isPatientFormDirty, visionInsuranceConfig, order } = props
  const [insuranceVerifying, setInsuranceVerifying] = useState(false)
  const [showVerifyBtn, setShowVerifyBtn] = useState(true)
  const dispatch = useDispatch()

  const { rpaVerificationFailed } = useInsuranceMappedFailed(selectedInsuranceName)
  const rpaVerifiedInsurance = isRpaVerifiedInsurance(visionInsuranceConfig, services, selectedInsuranceName)

  useEffect(() => {
    // Order Patient Load
    patientId && dispatch(patientLoad(patientId, { include: '*' }))
    return () => {
      dispatch(visionInsuranceEligibilityReset())
    }
  }, [])

  useEffect(() => {
    dispatch(visionInsuranceEligibilityReset())
  }, [orderId])

  useEffect(() => {
    selectedInsuranceName && dispatch(visionInsuranceEligibilityReset())
  }, [selectedInsuranceName])

  const getData = (data) => {
    // default structure
    let storeId = currentStoreId ?? (orderId && order.store_id)
    const insurance = getInsuranceFromRPAServices(services, selectedInsuranceName)
    data = { ...data, patient_id: patient.id, add_ons_id: insurance.id, insurance_payer: selectedInsuranceName, service: insurance.config.service, store_id: storeId, insurance_type: getInsuranceTypeBEName(insuranceType), other_details: { resource: "verify_eligibility", member_id: data.member_id } }
    // structure as per Order Verification
    data = { ...data, orders_order_id: isOrderView ? orderId : null }
    return data
  }

  const handleBeforeVerify = (data) => {
    if (isPatientView && isPatientFormDirty) {
      dispatch(submit("patientForm"))
      setTimeout(() => {
        let invalidInputs = document.getElementsByClassName("is-invalid")
        invalidInputs.length === 0 && handleVerify(data)
      }, 500)
    }
    else {
      handleVerify(data)
    }
  }

  const handleInsuranceVerifySubmit = (data) => {
    data = getData(data)
    handleBeforeVerify(data)
  }

  const handleVerify = (data) => {
    setInsuranceVerifying(insuranceType)
    dispatch(visionInsuranceEligibilityVerify(data)).then((res) => {
      res = res.value.data
      handleOnVerifySuccess(res)
    }).catch(() => {
      setInsuranceVerifying(false)
      setTimeout(() => setShowVerifyBtn(false), 7000);
      handleLoadUpdatedLogs()
    })
  }

  const handleOnVerifySuccess = (res) => {
    dispatch(visionInsuranceDetailView({ visible: true, file_url: res.rpa_vision_insurance_log.eligibility_file_url, service: res.rpa_vision_insurance_log.service }))
    setInsuranceVerifying(false)
    setTimeout(() => setShowVerifyBtn(false), 7000);
    handleLoadUpdatedLogs()
  }

  const handleLoadUpdatedLogs = () => {
    // load to get verify new logs
    isOrderView && dispatch(orderLoad(orderId, { include: '*' }));
    isPatientView && dispatch(patientLoad(patient.id, { include: '*' }));
  }

  return (
    <>
      {(rpaVerifiedInsurance || rpaVerificationFailed) && <RenderRPAService pprops={{ ...props, handleInsuranceVerifySubmit, insuranceVerifying, showVerifyBtn, setShowVerifyBtn, rpaVerificationFailed }} />}
    </>
  )
}

const mapStateToProps = (state) => {
  const { patient: { patient }, currentStore: { store }, visionInsurance: { services }, organisation: { organisation } } = state

  return {
    patient,
    currentStoreId: store.id,
    services,
    isPatientFormDirty: isDirty('patientForm')(state),
    visionInsuranceConfig: organisation.add_ons_config?.type?.vision_insurance,
  }
}

export default connect(mapStateToProps)(RPAInsuranceVerify);